import _ from 'lodash'
const pinyinReg =
  /^((([mM]iu|[pmPM]ou|[bpmBPM](o|e(i|ng?)?|a(ng?|i|o)?|i(e|ng?|a[no])?|u))|([fF](ou?|[ae](ng?|i)?|u))|([dD](e(i|ng?)|i(a[on]?|u))|[dtDT](a(i|ng?|o)?|e(i|ng)?|i(a[on]?|e|ng|u)?|o(ng?|u)|u(o|i|an?|n)?))|([nN]eng?|[lnLN](a(i|ng?|o)?|e(i|ng)?|i(ang|a[on]?|e|ng?|u)?|o(ng?|u)|u(o|i|an?|n)?|ve?))|([ghkGHK](a(i|ng?|o)?|e(i|ng?)?|o(u|ng)|u(a(i|ng?)?|i|n|o)?))|([zZ]h?ei|[czCZ]h?(e(ng?)?|o(ng?|u)?|ao|u?a(i|ng?)?|u?(o|i|n)?))|([sS]ong|[sS]hua(i|ng?)?|[sS]hei|[sS][h]?(a(i|ng?|o)?|en?g?|ou|u(a?n|o|i)?|i))|([rR]([ae]ng?|i|e|ao|ou|ong|u[oin]|ua?n?))|([jqxJQX](i(a(o|ng?)?|[eu]|ong|ng?)?|u(e|a?n)?))|(([aA](i|o|ng?)?|[oO]u?|[eE](i|ng?|r)?))|([wW](a(i|ng?)?|o|e(i|ng?)?|u))|[yY](a(o|ng?)?|e|in?g?|o(u|ng)?|u(e|a?n)?))[0-5])$/
const pinyinLib = {
  ue1: 'uē',
  ue2: 'ué',
  ue3: 'uě',
  ue4: 'uè',
  a1: 'ā',
  e1: 'ē',
  i1: 'ī',
  o1: 'ō',
  u1: 'ū',
  v1: 'ǖ',
  a2: 'á',
  e2: 'é',
  i2: 'í',
  o2: 'ó',
  u2: 'ú',
  v2: 'ǘ',
  a3: 'ǎ',
  e3: 'ě',
  i3: 'ǐ',
  o3: 'ǒ',
  u3: 'ǔ',
  v3: 'ǚ',
  a4: 'à',
  e4: 'è',
  i4: 'ì',
  o4: 'ò',
  u4: 'ù',
  v4: 'ǜ',
}
let pinyinLibReverse = {}

for (let pinyin in pinyinLib) {
  pinyinLibReverse[pinyinLib[pinyin]] = {
    pinyin: pinyin.slice(0, pinyin.length - 1),
    tone: pinyin.charAt(pinyin.length - 1),
  }
  pinyinLibReverse = {
    ...pinyinLibReverse,
    a: { pinyin: 'a', tone: '5' },
    e: { pinyin: 'e', tone: '5' },
    i: { pinyin: 'i', tone: '5' },
    o: { pinyin: 'o', tone: '5' },
    u: { pinyin: 'u', tone: '5' },
    üe: { pinyin: 'ue', tone: '5' },
    ńg: { pinyin: 'en', tone: '2' },
    ňg: { pinyin: 'en', tone: '3' },
    ǹg: { pinyin: 'en', tone: '4' },
    ń: { pinyin: 'en', tone: '2' },
    ň: { pinyin: 'en', tone: '3' },
    ǹ: { pinyin: 'en', tone: '4' },
  }
}
const TONE_PRIORITIES = ['a', 'e', 'o', ['iu', 'u'], ['ui', 'i'], 'i', 'u', 'v']

function convertPinyin(pinyin) {
  //a1 ==> ā

  if (!pinyin) return ''
  let _pinyin = pinyin.split('')
  if (_.isNaN(+pinyin[pinyin.length - 1])) {
    _pinyin.push(5)
  }
  let tone = _pinyin.pop()
  if (_pinyin.join('').indexOf('ue') > -1)
    return _pinyin.join('')?.replace('ue', pinyinLib['ue' + tone] || 'ue')
  let output
  _.forEach(TONE_PRIORITIES, (group) => {
    const sound = Array.isArray(group) ? group[0] : group
    if (_pinyin.join('').indexOf(sound) >= 0) {
      const replacing = Array.isArray(group) ? group[1] : group
      if (pinyinLib[replacing + '' + tone]) {
        output = _pinyin.join('')?.replace(replacing, pinyinLib[replacing + '' + tone] || replacing)
        return false
      }
    }
  })
  return output || _pinyin.join('')
}

function reversePinyin(pinyin, toString) {
  //ā ==> a1
  let _pinyin = pinyin?.replace('ü', 'u').split('') //.reverse()
  let output = {
    pinyin: '',
    tone: '',
  }
  // _.forEach(pinyinLibReverse, (key, index) => {
  //   if (_pinyin.indexOf(key) > -1) {

  //   }
  // })
  _.forEach(_pinyin, (key, index) => {
    if (pinyinLibReverse[key]) {
      if (Number(output.tone) == 5 || output.tone == '') {
        output.tone = pinyinLibReverse[key].tone
      }
      pinyin = pinyin?.replace(key, pinyinLibReverse[key].pinyin)
    }
  })
  output.pinyin = pinyin
  // console.log(output.pinyin, output.tone)
  if (toString) {
    return `${output.pinyin}${output.tone}`
  } else {
    return output
  }
}

function checkPinyin(pinyin) {
  return pinyinReg.test(pinyin)
}

function getToneNum(pinyin) {
  // a1 -> 1
  // a -> 5

  let tone = ''

  if (pinyin) {
    let lastChar = pinyin[pinyin.length - 1]
    lastChar = Number.parseInt(lastChar)

    tone = _.isNaN(lastChar) ? 5 : lastChar
  }
  return tone
}

function getPinyinContent(pinyin) {
  // a1 -> a
  let content = ''
  if (pinyin) {
    content = pinyin?.substr(0, pinyin.length - 1)
  }
  return content
}

export { convertPinyin, checkPinyin, reversePinyin, getToneNum, getPinyinContent }
